import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { createLogger } from 'redux-logger';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
  PERSIST_KEY,
  PERSIST_THROTTLE_MS,
} from '@bbkAdminRedux/persist-config';
import { reducersMiddlewares } from '@bbkAdminRedux/reducers-middlewares';
import { rootReducer } from '@bbkAdminRedux/root-reducer';
import { appPersistSlice } from '@bbkAdminRedux/rtkq/app-persist/app-persist.slice';
import { authPersistedSlice } from '@bbkAdminRedux/rtkq/brightback-auth.slice';
import { datepickerPersistSlice } from '@bbkAdminRedux/rtkq/datepicker-persist.slice';

const DEBUGGER = new URLSearchParams(window.location.search).has('debugger');

const persistConfig = {
  key: PERSIST_KEY,
  // The session metadata (`type`) has to survive a reload: it is all the
  // frontend knows about the session, since the credential itself is an
  // unreadable HttpOnly cookie. Without it a fresh page load cannot tell a
  // returning session from a first visit.
  whitelist: [
    appPersistSlice.name,
    datepickerPersistSlice.name,
    authPersistedSlice.name,
  ],
  storage,
  throttle: PERSIST_THROTTLE_MS,
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const makeStore = () =>
  configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }).concat(
        ...reducersMiddlewares,
        ...(DEBUGGER ? [createLogger()] : [])
      ),
    devTools: process.env.NODE_ENV !== 'production',
  });

const store = makeStore();

const persistor = persistStore(store);

setupListeners(store.dispatch);

window.bbkStore = store;

export { store, persistor };
